import {Component, inject, Input} from '@angular/core';
import {AddressEdit} from "../../Controlls/AddressEdit";
import {GeschlechtsAuswahl} from "../../Controlls/GeschlechtsAuswahl";
import {Phonenumber} from "../../../Directives/Phonenumber";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap/modal';
import {CommonModule} from '@angular/common';
import { Geraet } from '../../../Api/DcoApi/AktenEintraege/Geraet';
import {SeriennummerSelect} from '../../Controlls/SearchAndSelect/SeriennummerSelect';
import {RestClient} from '../../../Api/DcoApi/Client/RestClient';

@Component({
  selector: 'app-rotate-device',
  imports: [
    CommonModule, FormsModule,
    ReactiveFormsModule, SeriennummerSelect
  ],
  templateUrl: './rotate-device.html',
  styleUrl: './rotate-device.css',
})
export class RotateDevice {
  modal = inject(NgbActiveModal);
  Device: Geraet | null = null;
  Client: RestClient = new RestClient();
  @Input() Auftrag: number = 0;
  async Rotate(){
    await this.Client.Post<any,any>(`/Backend/Api/V2/Austausch/${this.Auftrag}?ReplaceDeviceSerial=${this.Device?.seriennummer}`, null)
    this.modal.close(true);
  }
}
